<template>
    <div>
        <div style="background: #eee">
            <div class="content">
                <div class="flex-center-y center" style="background: #fff">
                    <img :src="downloadImg + detail.image"/>
                    <div class="name" style="font-size: 14px">
                        <div class="title">{{detail.name}}</div>
                        <div style="color: #7e7e7e">{{detail.remark}}</div>
                    </div>
                </div>
            </div>
            <CellGroup v-for="template in detail.templatelist" :key="template.id" :title="template.name">
                <Cell v-for="item in template.subjectlist" :key="item.id" :title="item.name">
                    <span v-if="item.pass" style="color: #07c160">合格&nbsp;&nbsp;</span>
                    <span v-else style="color:#f5222d">不合格</span>
                    <TSwitch slot="default" v-model="item.pass" size="20" style="position: relative;top: 5px;"
                             :disabled="!canEdit"
                             @change="submitTemplateSubject(item)" v-if="canEdit"/>
                </Cell>
            </CellGroup>
            <CellGroup title="其他">
                <!-- <div style="padding: 8px 18px;border-bottom: 1px solid #ebedf0">
                    <div class="flex-center-y">
                        <Icon name="location"/>&nbsp;
                        <div style="width: calc(100% - 60px)">当前位置</div>
                        <Button @click="refresh" size="small" block type="info" style="width:40px;">刷新</Button>
                    </div>
                    <div style="color: #7e7e7e;">{{position.address}}</div>
                </div> -->
                <Field :required="canEdit" label="是否正常" center  input-align="right">
                    <RadioGroup slot="input" v-if="canEdit" v-model="detail.normal" direction="horizontal"
                                :disabled="!canEdit"
                                style="justify-content: center"
                    >
                        <Radio :name="true" shape="square"><span style="color: green">正常</span></Radio>
                        <Radio :name="false" shape="square"><span style="color: red">异常</span></Radio>
                    </RadioGroup>
                    <span v-else slot="input">
                            <span v-if="detail.normal" style="color:#07c160">正常</span>
                            <span v-else style="color:#f5222d">异常</span>
                        </span>
                </Field>
                <div v-if="!canEdit">

                    <Field
                            label="处理人"
                            v-model="detail.handleUserName"
                            clearable input-align="right"
                            :disabled="!canEdit"
                    />
                    <Field
                            label="处理时间"
                            v-model="detail.handleTime"
                            clearable input-align="right"
                            :disabled="!canEdit"
                    />
                    <div></div>
                </div>
                <div>
                    <Field
                            v-model="detail.handleRemark"
                            type="textarea"
                            clearable
                            :disabled="!canEdit"
                            placeholder="异常原因描述（如需）"
                    />
                </div>
                <div style="display:flex;justify-content : space-between;width:90%;margin:auto;padding-bottom: 8px">
                    <UploadImage
                            :imageList="handleImageList"
                            :sourceType="['camera']"
                            style="margin-top:5px;margin-left:-15px"
                            type="SafetyImage"
                            :count="9"
                            @imageChange="imageChange"
                            :edit="canEdit"
                    />
                </div>
            </CellGroup>
        </div>
        <pf code="SAFETY_TASK_HANDLE">
            <Button v-if="canEdit" type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">确认提交
            </Button>
        </pf>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Field, Form, Icon, NavBar, Popup, Radio, RadioGroup, Switch} from "vant"
    import UploadImage from "@/components/UploadImage";
    import {mapGetters} from "vuex";
    import {downloadImg} from "@/config"

    export default {
        components: {
            UploadImage, RadioGroup, Radio, CellGroup, Cell,
            Popup, Form, Field, Button, NavBar, TSwitch: Switch,
            Icon
        },
        props: {},
        data() {
            return {
                downloadImg,
                taskPointId: this.$route.params.id,
                mapPanel: false,
                detail: {
                    normal: null,
                    handleRemark: '',
                    handleImageList: [],
                    templatelist: []
                }
            }
        },
        computed: {
            ...mapGetters({position: 'wechat/position'}),
            handleImageList() {
                return this.detail.handleImageList !== null && this.detail.handleImageList ? this.detail.handleImageList : []
            },
            canEdit() {
                return this.$route.name == 'submit'
            },
        },
        created() {
        },
        mounted() {
            this.getDetail()
            this.refresh()
        },
        methods: {
            getDetail() {
                this.$http.tokiot.safety.task.position.get({id: this.taskPointId})
                    .then(detail => {
                        if (detail) {
                            detail.handleImageList = detail.handleImageList || []
                            this.detail = detail
                        }
                    })
            },
            refresh() {
                const position = this.$store.dispatch({type: 'wechat/getLocation'});
                // console.info('position',position)
            },
            submit() {
                if (this.detail.handleImageList.length == 0) {
                    this.$toast.fail('打卡照片必须上传')
                    return
                }
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.safety.task.position.submit({
                    id: this.detail.id,
                    subAddress: this.position.address,
                    handleLat: this.position.latitude,
                    handleLng: this.position.longitude,
                    handleRemark: this.detail.handleRemark,
                    normal: this.detail.normal,
                    handleImageList: this.detail.handleImageList,
                }).then(res => {
                    if (res) {
                        this.$toast.success("打卡成功")
                        this.$router.go(-1)
                    } else {
                        this.$toast.fail(res.message)
                    }
                })
            },
            submitTemplateSubject(item) {
                this.$http.tokiot.safety.task.position
                    .submitTemplateSubject(item)
                    .then(ret => {
                        if (ret) {
                            return
                        } else {
                            item.pass = !item.pass
                        }
                    })
            },

            imageChange(imageList) {
                this.detail.handleImageList = imageList;
            },
        },
        watch: {
            detail: {
                handler(detail) {
                    if (!this.canEdit || detail.templatelist.length == 0) return
                    let template, item
                    for (let i = 0; i < detail.templatelist.length; i++) {
                        template = detail.templatelist[i]
                        for (let j = 0; j < template.subjectlist.length; j++) {
                            item = template.subjectlist[j]
                            if (!item.pass) { // 不通过
                                this.detail.normal = false
                                return
                            }
                        }
                    }
                    this.detail.normal = true
                },
                deep: true
            }
        }
    }
</script>

<style lang="less" scoped>
    .content {
        width: 100%;

        & > .center {
            padding: 12px 18px;
            // padding: 10px;
            display: flex;
            & > img {
                width: 65px;
                height: 65px;
                background: #cccccc;
                // border-radius: 8px;
            }
            & > .name {
                padding-left: 20px;
                height: 100%;
                display: flex;
                flex-direction: column;
                & > div {
                    line-height: 1.5;
                }
            }
        }
    }


</style>